function initHeaderLogoDropdown() {
  document.querySelectorAll('.header-logo-trigger').forEach((trigger) => {
    const logoContainer = trigger.closest('.header-logo');
    const dropdown = logoContainer?.querySelector('.header-logo-dropdown');

    if (!dropdown) {
      return;
    }

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = dropdown.classList.contains('active');
      document.querySelectorAll('.header-logo-dropdown.active').forEach((openDropdown) => {
        openDropdown.classList.remove('active');
      });
      document.querySelectorAll('.header-logo-trigger[aria-expanded="true"]').forEach((openTrigger) => {
        openTrigger.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        dropdown.classList.add('active');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.header-logo').forEach((logoContainer) => {
      const dropdown = logoContainer.querySelector('.header-logo-dropdown');
      const trigger = logoContainer.querySelector('.header-logo-trigger');

      if (!dropdown || !trigger || logoContainer.contains(event.target)) {
        return;
      }

      dropdown.classList.remove('active');
      trigger.setAttribute('aria-expanded', 'false');
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeaderLogoDropdown);
} else {
  initHeaderLogoDropdown();
}
